import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformManifestServicesErrorCode {
  ComponentNotExistsInEERegistry = "Component doesn't exist in EE Registry",
  LoadManifestFromCDNError = "Can't load manifest from CDN",
  ManifestUrlNotProvided = 'Manifest URL not provided',
  MultipleManifestsLoadingFailed = 'Multiple manifests loading failed',
  MultipleManifestsResolvingFailed = 'Multiple manifests resolving failed',
  FailedToResolveManifest = 'Failed to resolve manifest',
  NoSuchHandlerToGetManifestData = 'There is no such handler for retrieving root manifest data',
  CanNotGetManifestByInnerElPath = "Can't get element manifest by inner element path",
}

class EditorPlatformManifestServicesError extends BaseError<EditorPlatformManifestServicesErrorCode> {
  constructor(message: string, code: EditorPlatformManifestServicesErrorCode) {
    super(message, code, 'Editor Platform Manifest Services Error');
  }

  withMultipleErrors(errors: Error[]) {
    this.state.errors = `Multiple errors occurred: ${errors
      .map((e) => e.message)
      .join(', ')}`;
    return this;
  }

  withComponentType(componentType: string) {
    this.state.componentType = componentType;
    return this;
  }
}

export const createEditorPlatformManifestServicesError = createErrorBuilder<
  EditorPlatformManifestServicesErrorCode,
  EditorPlatformManifestServicesError
>(EditorPlatformManifestServicesError);
